var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvaluaitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 36,
    viewBox: "0 0 198 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.041 18.4025V12.6751L16.8961 5.06982L3.70428 12.6751V27.8856L16.8961 35.4908L30.041 27.8856V23.144L25.9567 25.4913L21.5907 28.0264L16.8961 30.7493L7.83553 25.4913V15.0224L16.8961 9.76443L25.9567 15.0224V20.7498L30.041 18.4025Z",
    fill: "#014935"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0087 18.9707L22.1546 22.9611L18.0703 25.3084V20.5668L22.1546 18.2195L26.9901 15.4497L29.0087 18.9707Z",
    fill: "#014935"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2607 2.19678H15.5848V9.09785H18.2607V2.19678Z",
    fill: "#014935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6942 3.33236L16.8726 0.510742L14.0509 3.33236L16.8726 6.15398L19.6942 3.33236Z",
    fill: "#014935"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67591 23.7531H0.375562C0.140832 23.7531 0 23.5654 0 23.3776V16.5704C0 16.3357 0.187778 16.1948 0.375562 16.1948H2.67591V23.7531Z",
    fill: "#014935"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4196 23.7531H31.1193V16.1948H33.4196C33.6543 16.1948 33.7952 16.3826 33.7952 16.5704V23.3776C33.7952 23.5654 33.6074 23.7531 33.4196 23.7531Z",
    fill: "#014935"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.659 29.6213V12.5348H192.042V29.6213H189.659ZM183.677 14.208V12.0278H198V14.208H183.677Z",
    fill: "#014935"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.39 29.6213V12.0278H175.773V29.6213H173.39Z",
    fill: "#F05A28"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.576 29.6213L156.775 12.0278H158.499L165.674 29.6213H163.088L157.181 14.7404H158.068L152.111 29.6213H149.576ZM152.998 25.6412V23.5625H162.251V25.6412H152.998Z",
    fill: "#F05A28"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.626 29.8748C134.325 29.8748 133.159 29.5875 132.128 29.0129C131.114 28.4214 130.311 27.6186 129.719 26.6046C129.128 25.5736 128.832 24.4075 128.832 23.1062V12.0278H131.215V23.0555C131.215 23.985 131.409 24.7878 131.798 25.4638C132.187 26.1398 132.711 26.6637 133.37 27.0355C134.046 27.4073 134.798 27.5933 135.626 27.5933C136.488 27.5933 137.24 27.4073 137.882 27.0355C138.542 26.6637 139.057 26.1398 139.429 25.4638C139.818 24.7878 140.012 23.9934 140.012 23.0808V12.0278H142.42V23.1315C142.42 24.4328 142.124 25.5905 141.533 26.6046C140.941 27.6186 140.139 28.4214 139.125 29.0129C138.111 29.5875 136.944 29.8748 135.626 29.8748Z",
    fill: "#014935"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.595 29.6213V12.0278H112.977V29.6213H110.595ZM112.217 29.6213V27.4412H121.647V29.6213H112.217Z",
    fill: "#014935"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7804 29.6213L93.98 12.0278H95.7039L102.878 29.6213H100.292L94.3856 14.7404H95.2729L89.3154 29.6213H86.7804ZM90.2027 25.6412V23.5625H99.4558V25.6412H90.2027Z",
    fill: "#014935"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7108 29.6213L66.6633 12.0278H69.2491L75.0544 26.9088H74.1164L79.9725 12.0278H82.5329L75.4347 29.6213H73.7108Z",
    fill: "#014935"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2748 29.6213V12.0278H50.6578V29.6213H48.2748ZM49.8972 29.6213V27.4412H59.9869V29.6213H49.8972ZM49.8972 21.6612V19.5824H59.1503V21.6612H49.8972ZM49.8972 14.208V12.0278H59.8601V14.208H49.8972Z",
    fill: "#014935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluaitLogo);
export default __webpack_public_path__ + "static/media/evaluait-logo.be9c415de691052df02aa83fb4bf318b.svg";
export { ForwardRef as ReactComponent };